// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import getStorage

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// IMPORTANT: For security, store this configuration in environment variables
// and access them like process.env.REACT_APP_API_KEY, etc.
// See https://create-react-app.dev/docs/adding-custom-environment-variables/
const firebaseConfig = {
  apiKey: "AIzaSyCTTJXktvP7P2jiUgZZRmuHQBMBvgl8FSM",
  authDomain: "knuckleheads-3e6c1.firebaseapp.com",
  projectId: "knuckleheads-3e6c1",
  storageBucket: "knuckleheads-3e6c1.firebasestorage.app",
  messagingSenderId: "684787004406",
  appId: "1:684787004406:web:80557240ef0b327fd10dd7",
  measurementId: "G-FZL6Y7SZEQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const storage = getStorage(app); // Initialize Firebase Storage

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export { db, storage }; // Export db and storage